import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { OrdersWithPickupStateModel, SetVisibleColumns } from '@data/orders-with-pickup/orders-with-pickup.actions';

const DEFAULTS: OrdersWithPickupStateModel = {
  visibleColumns: [],
};

@State<OrdersWithPickupStateModel>({
  name: 'ordersWithPickup',
  defaults: DEFAULTS,
})
@Injectable()
export class OrdersWithPickupState {
  @Selector()
  static visibleColumns(state: OrdersWithPickupStateModel): string[] {
    return state.visibleColumns;
  }

  @Action(SetVisibleColumns)
  setVisibleColumns(ctx: StateContext<OrdersWithPickupStateModel>, action: SetVisibleColumns): void {
    ctx.patchState({
      visibleColumns: action.columns,
    });
  }
}
